import { Icon } from "../icon";
import type { IconName } from "../icon/IconName";
import "./button.css"

interface ButtonProps {
    className?: string;
    isLoading?: boolean;
    leftIcon?: IconName;
    rightIcon?: IconName;
    label?: string;
    onClick?: () => void;
    type?: "submit" | "reset" | "button";
    variant?: "primary" | "secondary" | "soft" | "destructive"
}

export const Button = ({className, isLoading=false, label, leftIcon, rightIcon, type = "button", variant = "primary", onClick}: ButtonProps) => {
    return (
        <button className={`btn btn-${isLoading ? `loading` : variant} ${className ? className : ""}`} onClick={onClick} type={type}>
            {leftIcon && <Icon className="left-icon" name={leftIcon} size="small"></Icon>}
            {isLoading ? <div ><Icon className="btn-loading-icon" name="loading"></Icon></div> : <div className="btn-label">{label}</div>}
            {rightIcon && <Icon className="right-icon" name={leftIcon} size="small"></Icon>}
        </button>
    )
};
